module.exports = __webpack_public_path__ + "img/ui-library.c921db41.svg";